import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { type: { type: String, default: "success" } }

  // Auto-close removido durante o evento Vila Lobos: toast fica na tela
  // até o usuário fechar pelo botão X (facilita suporte/leitura).
  connect() {
    requestAnimationFrame(() => {
      this.element.classList.add("toast--visible")
    })

    if (this.typeValue === "win") {
      document.dispatchEvent(new CustomEvent("sabor-bet:win"))
    }
  }

  dismiss() {
    this.element.classList.add("toast--exiting")
    setTimeout(() => this.element.remove(), 300)
  }
}
